const criticFilterPref = {
    languages: [
        {
            name: "English",
            icon: "",
            value: "English",
        },
        {
            name: "Hindi",
            icon: "",
            value: "Hindi",
        },
    ],

    genres: [
        {
            name: "Crime",
            icon: "",
            value: "Crime",
        },
        {
            name: "Horror",
            icon: "",
            value: "Horror",
        },
    ],

    status: [
        {
            name: "Pending",
            icon: "",
            value: "pending",
        },
        {
            name: "Completed",
            icon: "",
            value: "completed",
        },
    ],
};

export default criticFilterPref;
